import type { IdentityDto } from '@_/api-contracts/public-api.ts';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { getReactQueryOptions } from '@_/utils-frontend';
import { publicApiQueryClient } from '#src/api.ts';
import { OnboardIdentityPage } from '#src/pages/OnboardingPage/index.ts';

export const Route = createFileRoute('/{-$locale}/onboarding/_wrapper/identities_/{-$identityId}')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const { identityId } = params;

    let identity: IdentityDto | undefined;
    if (identityId) {
      const resp = await queryClient.ensureQueryData(
        getReactQueryOptions(publicApiQueryClient.identities.get, {
          params: { id: identityId }
        })
      );

      identity = resp.data;
    }

    // This page is for setting up child identities only
    if (identity?.isDefault) {
      throw notFound();
    }

    return {
      identity
    };
  }
});

function RouteComponent() {
  const { identity } = Route.useLoaderData();

  return <OnboardIdentityPage identity={identity} />;
}
